import { useInfiniteQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { fetchKpiEventLog } from '../../../api/objective/objective.api';
import { EVENT_LOG_LIMIT } from '../../../utils/const';
import { addAlert } from '../../../actions/alerts.action';
/**
 * Custom React hook to fetch KPI event logs using infinite pagination.
 *
 * @param {Object} objective    - The objective related to the KPI.
 * @param {string} objective.id - Objective ID.
 * @param {Object} kpi          - The KPI of the objective object.
 * @param {string} subjectType  - Subject type to be used in the logs (e.g., 'KPIS').
 *
 * @returns {Object}            - An object containing infinite query result
 */
export default function useKpiEventLogs({
  objective,
  kpi,
  subjectType
}) {
  const dispatch = useDispatch();

  const [ objectiveOwner ] = objective?.owner;

  return useInfiniteQuery(
    [ 'objectiveKpiLogs', objectiveOwner?.id, objective?.id, kpi?.objective_kpi_id, subjectType ],
    async ({ pageParam = 1 }) => {
      const { data } = await fetchKpiEventLog({
        ownerId: objectiveOwner.id,
        ownerType: objectiveOwner.type,
        objectiveId: objective.id,
        kpiId: kpi.objective_kpi_id,
        createdAt: objective.created_at,
        subjectType,
        pageNumber: pageParam
      });
      return data;
    },
    {
      getNextPageParam: (lastPage, pages) =>
        lastPage?.length % EVENT_LOG_LIMIT === 0 ?
          pages.flat().length / EVENT_LOG_LIMIT + 1 :
          undefined,
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );
}
